/**
 * @format
 * @flow strict-local
 */
// DEPENDENCIES

import React, {
	useEffect,
	useState
} from "react";
import {
	useNavigate
} from "react-router-dom";

import {
	ComponentWrapper
} from "./ResendActivationCode.styled";

import Button from "../../components/Button";
import Card, {
	CardBody,
	CardFooter,
	CardHeader
} from "../../components/Card";
import InputText from "../../components/InputText";
import InputWrapper from "../../components/InputWrapper";

import i18nHelper from "../../helpers/i18n";
import routerHelper from "../../helpers/router";
import storeHelper from "../../helpers/store";
import utilsHelper from "../../helpers/utils";

import useApi from "../../hooks/api";
import useForm from "../../hooks/form";

import i18n from "../../i18n";

// COMPONENT

const ResendActivationCode = (props) => {
	const [
		error, 
		setError
	] = useState(null);
	const [
		isRenderReady, 
		setIsRenderReady
	] = useState(false);

	const {
		fetchApi
	} = useApi();
	const {
		eventHandler,
		getFormValues,
		getInputErrorText,
		hasError,
		initForm,
		inputConfigs,
		inputs,
		inputStates,
		updateInputConfigs,
		updateInputErrors,
		updateInputs,
		updateInputStates,
		validateForm
	} = useForm();
	const navigate = useNavigate();

	// Lifecycle

	// Note - Run on bootstrap
	useEffect(
		() => {
			initInputs();
	    }, 
		[]
	);

	// Note - Run when inputs change
	useEffect(
		() => {
			if(utilsHelper.isObjectEmpty(inputs)) {
				return;
			}

			if(!isRenderReady) {
				setIsRenderReady(true);
			}
		}, 
		[inputs]
	);

	// Events

	/**
	 * goToSignIn - ...
	 * 
	 * @param {object} e ... 
	 */
	const goToSignIn = (e) => {
		navigate({
			pathname: routerHelper.getUrl("signIn")
		});
	};

	/**
	 * submitHandler - ...
	 * 
	 * @param {object} e ... 
	 */
	const submitHandler = async (e) => {
		if(
			!inputStates.isValid || 
			inputStates.isSubmit
		) {
			validateForm(false);

			return;
		}

		updateInputStates({
			isSubmit: true
		});

		const data = getFormValues();

		const response = await fetchApi({
			method: "get",
			params: {
				service: "resendActivationCode",
				...data
			}
		});

		if(response.error) {
			switch(response.error.code) {
				default:
					setError(response.error.message || response.error.code);
				break;
			}

			updateInputStates({
				isSubmit: false,
				isValid: false
			});

			return;
		}
		
		updateInputStates({
			isSubmit: false,
			isSubmitted: true
		});
	};

	// Misc

	/**
	 * initInputs - ...
	 */
	const initInputs = () => {
		const newForm = {
			email: {
				formatter: "lowercase",
				initialValue: "",
				inputErrorType: "email",
				inputType: "text",
				touched: false,
				validators: {
					email: true,
					required: true
				}
			}
		};

		initForm(newForm);
	};

	// Render

	/**
	 * render - ...
	 */
	const render = () => {
		if(!isRenderReady) {
			return null;
		}

		let errorContent;
		let successContent;

		if(error) {
			errorContent = (
				<div
					style={{
						borderRadius: "8px",
						backgroundColor: "#F04124",
						color: "#fff",
						padding: "16px"
					}}
					>
					{error}
				</div>
			);
		} else if(inputStates.isSubmitted) {
			successContent = (
				<div
					style={{
						borderRadius: "8px",
						backgroundColor: "#20B651",
						color: "#fff",
						padding: "16px"
					}}
					>
					An email will be sent shortly with instructions on resetting your password.
				</div>
			);
		}

		return (
			<ComponentWrapper>
				{errorContent}
				{successContent}
				<Card
					className="card"
					>
					<CardHeader>
						<strong>
							Resend activation code
						</strong>
						<p>
							Enter your email address and we'll get you back on track.
						</p>
					</CardHeader>
					<CardBody
						className="cardBody"
						>
						<InputWrapper
							label="Email"
							>
							<InputText
								name="email"
								onBlur={eventHandler}
								onChange={eventHandler}
								type="email"
								{...inputs.email}
							/>
						</InputWrapper>
					</CardBody>
					<CardFooter>
						<Button
							className="footerButton"
							disabled={
								!isRenderReady ||
								inputStates.isSubmit ||
								!inputStates.isValid
							}
							label="Resend activation code"
							loaderActive={inputStates.isSubmit}
							loaderEnable
							onClick={submitHandler}
							paletteColor={inputStates.isValid ? "dark" : "disabled"}
							type="submit"
						/>
					</CardFooter>
				</Card>
				<a
					onClick={goToSignIn}
					>
					Back to Sign in
				</a>
			</ComponentWrapper>
		);
	};

	return render();
};

// EXPORT

export default ResendActivationCode;
